import type { PackageData as PackageDataRaw } from '@wix/ambassador-appmarket-v1-app-market-client-aggregator/types';
import type { PackageDataType } from './types';

export class PackageData {
  constructor(private readonly packageData: PackageDataRaw) {}

  toJSON(): Omit<PackageDataType, 'icon'> {
    return {
      id: this.packageData.id ?? '',
      title: this.packageData.title ?? '',
      teaser: this.packageData.teaser ?? '',
      enabled: this.packageData.enabled ?? false,
      description: this.packageData.description ?? '',
      image: this.packageData.image ?? '',
      subcats: (this.packageData.subcats ?? []).map((subcat) => ({
        id: subcat.id ?? '',
        title: subcat.title ?? '',
      })),
      installableAppIds: this.packageData.installableAppIds ?? [],
      landingPageId: this.packageData.landingPageId ?? '',
    };
  }
}
